










import { Prop, Component, Vue } from 'vue-property-decorator';
import { Tooltip } from 'element-ui';

@Component({
  components: {
    'el-tooltip': Tooltip
  }
})
export default class CopyShipment extends Vue {
  @Prop({ required: true }) public shipmentId!: string;
}
